import { observable, action } from 'mobx';
import intl from 'react-intl-universal';
import enUS from '../locale/en';
import zhCN from '../locale/zh_CN';
import moment from 'moment';
import RootStore from './RootStore';
import {getLocalConfig} from '../utils/util';

const getLocaleMessages = (name: string) => {
  if(name == 'en-US') {
    return {
      ...enUS,
      ...(window.__locales ? window.__locales[name] : {})
    };
  }

  return {
    ...zhCN,
    ...(window.__locales ? window.__locales[name] : {})
  };

  // switch (name) {
  //   case 'en-US':
  //     return enUS;
  //   case 'zh-CN':
  //     return zhCN;
  //   default:
  //     return zhCN;
  // }
};

interface ILocaleStore {
  rootStore: RootStore;
}
export default class LocaleStore implements ILocaleStore {
  public rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    // const local = window.localStorage.getItem('lang');
    let config = getLocalConfig();
    let language = config.language;
    if(language == 'system') {
      language = '';
    }
    this.setLocale(language || '');
  }

  @observable locale = ''; //'en-US';//'zh-CN';
  @observable initDone = false;

  @action reloadLocale() {
    intl.load({
      [this.locale]:getLocaleMessages(this.locale)
    });
  }

  @action
  setLocale(locale: string) {
    //如果已经切换成当前语言了就不需要重新切换了
    if (locale && locale === this.locale) {
      return;
    }

    if (locale) {
      this.locale = locale || 'zh-CN';
      window.localStorage.setItem('lang', this.locale);
    } else {
      if (window.configDetail.locale) {
        this.locale = window.configDetail.locale;
      } else {
        this.locale = 'zh-CN';
      }
    }
    this.initDone = false;
    this.loadLocales();
    moment.locale(this.locale);
  }

  @action
  loadLocales() {
    const { locale } = this;
    const imageDomain =
      window.configDetail.use_global * 1 ? 'iglobal' : 'image';
    // init method will load CLDR locale data according to currentLocale
    // react-intl-universal is singleton, so you should init it only once in your app
    intl
      .init({
        currentLocale: locale, // en/en-US
        locales: {
          [locale]: getLocaleMessages(locale)
        },
        commonLocaleDataUrls: {
          en:
            '//' +
            imageDomain +
            '1' +
            window.__basename +
            '/npm/react-intl-universal/locale-data/1.0.0/en.js',
          zh:
            '//' +
            imageDomain +
            '1' +
            window.__basename +
            '/npm/react-intl-universal/locale-data/1.0.0/zh.js',
          fr:
            '//' +
            imageDomain +
            '1' +
            window.__basename +
            '/npm/react-intl-universal/locale-data/1.0.0/fr.js',
          fa:
            '//' +
            imageDomain +
            '1' +
            window.__basename +
            '/npm/react-intl-universal/locale-data/1.0.0/fa.js',
          ja:
            '//' +
            imageDomain +
            '1' +
            window.__basename +
            '/npm/react-intl-universal/locale-data/1.0.0/ja.js',
          de:
            '//' +
            imageDomain +
            '1' +
            window.__basename +
            '/npm/react-intl-universal/locale-data/1.0.0/de.js',
          es:
            '//' +
            imageDomain +
            '1' +
            window.__basename +
            '/npm/react-intl-universal/locale-data/1.0.0/es.js',
          ko:
            '//' +
            imageDomain +
            '1' +
            window.__basename +
            '/npm/react-intl-universal/locale-data/1.0.0/ko.js',
          pt:
            '//' +
            imageDomain +
            '1' +
            window.__basename +
            '/npm/react-intl-universal/locale-data/1.0.0/pt.js',
          it:
            '//' +
            imageDomain +
            '1' +
            window.__basename +
            '/npm/react-intl-universal/locale-data/1.0.0/it.js',
          ru:
            '//' +
            imageDomain +
            '1' +
            window.__basename +
            '/npm/react-intl-universal/locale-data/1.0.0/ru.js',
          pl:
            '//' +
            imageDomain +
            '1' +
            window.__basename +
            '/npm/react-intl-universal/locale-data/1.0.0/pl.js',
          nl:
            '//' +
            imageDomain +
            '1' +
            window.__basename +
            '/npm/react-intl-universal/locale-data/1.0.0/nl.js',
          sv:
            '//' +
            imageDomain +
            '1' +
            window.__basename +
            '/npm/react-intl-universal/locale-data/1.0.0/sv.js',
          tr:
            '//' +
            imageDomain +
            '1' +
            window.__basename +
            '/npm/react-intl-universal/locale-data/1.0.0/tr.js'
        }
      })
      .then(
        action(() => {
          // After loading CLDR locale data, start to render
          this.initDone = true;
        })
      );
  }
}
